export default "__VITE_ASSET__BfjZSk4V__"